<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <v-row>
      <v-col>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          color="primary"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <base-material-card
          v-if="!loading"
          color="primary"
          icon="mdi-account-multiple"
          inline
        >
          <template v-slot:after-heading>
            <div class="display-2 font-weight-light">
              Add Deposit User to Group {{ id }}
            </div>
          </template>
          <v-row>
            <v-spacer />
            <v-dialog
              v-model="dialog"
              max-width="500px"
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  class="mr-2"
                  color="warning"
                  to="/reportsgroup"
                >
                  Return
                </v-btn>
                <v-btn
                  color="primary"
                  dark
                  class="mb-2 mr-4"
                  v-on="on"
                >
                  New Deposit User to All Sites
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                      >
                        <v-text-field
                          v-model="editedItem.username"
                          label="User Name"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                      >
                        <v-text-field
                          v-model="editedItem.email"
                          label="Notification Email Address"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                      >
                        <v-select
                          v-model="editedItem.usertype"
                          :items="typeList"
                          label="Deposit User Type"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                      >
                        <v-text-field
                          v-model="editedItem.accesscode"
                          label="Access Code (1234)"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="close"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    :disabled="!formIsValid"
                    text
                    @click="save"
                  >
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
          <v-data-table
            :headers="headers"
            :items="group_safe_data"
            :search="searchdaily"
            sort-by="timestamp"
            sort-desc
            class="elevation-1"
          >
            <template v-slot:top>
              <v-toolbar
                flat
                color="white"
              >
                <v-toolbar-title>Group Sites</v-toolbar-title>
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                />
                <v-text-field
                  v-model="searchdaily"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                />
              </v-toolbar>
            </template>
            <template v-slot:[`item.sum`]="{ item }">
              {{ format_amt(item.sum) }}
            </template>
            <template v-slot:no-data>
              <div class="display-2 font-weight-light">
                Sorry, no messages to display for Smart Safe ID {{ id }}
              </div>
              <br>
            </template>
          </v-data-table>
        </base-material-card>

        <div class="py-3" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import moment from 'moment'
  var numeral = require('numeral')

  export default {
    name: 'Reportgroupcashin',
    props: ['id'],

    data () {
      return {
        date: '',
        date2: '',
        startdate: moment().subtract(1, 'day').format('YYYY-MM-DD'),
        enddate: moment().subtract(1, 'day').format('YYYY-MM-DD'),
        menu: false,
        menu1: false,
        filenamedate: '',
        searchdaily: '',
        id: '',
        loading: false,
        sites: this.$store.getters.loadedSites,
        profiles: this.$store.getters.loadedSiteProfiles,
        locations: [],
        groupsites: [],
        headers: [
          { text: 'Site Name', value: 'siteid', align: 'left' },
        ],
        icons: true,
        centered: true,
        newtab: null,
        activeBtn: 1,
        editedIndex: -1,
        editedItem: {
          username: '',
          accesscode: '',
          usertype: '',
          email: ''
        },
        defaultItem: {
          username: '',
          accesscode: '',
          usertype: '',
          email: ''
        },
      }
    },
    computed: {
      dateRangeText () {
        return this.dates
      },
      formIsValid () {
        return this.editedItem.email !== '' &&
          this.editedItem.accesscode !== '' &&
          this.editedItem.username !== ''
      },
      csvfilename () {
        let today = moment().format('YYYY-MM-DD')
        let filename = this.startdate + 'to' + this.enddate + '_' + this.id + '.csv'
        return filename
      },
      totalSales () {
        return this.sales.reduce((acc, val) => acc + val.salesInM, 0)
      },
      group_safe_data () {
        this.$log.debug('group safe data is ', this.$store.getters.cashingroupvalues)
        return this.$store.getters.cashingroupvalues
      },
      grouplist () {
        // return []
        let groups = this.$store.getters.usergroups.map(
          group => group.name
        )
        return this.$store.getters.usergroups
      },
      getlocs () {
        this.locations = []
        for (let [key, value] of Object.entries(this.$store.getters.loadedSiteProfiles)) {
          let name = 'Unknown'
          let loc = this.$store.getters.loadedSites.find(function (site) {
            if (site.idnum === key) {
              return site
            }
          })
          if (loc) {
            this.$log.debug('****** loc is ', loc)
            name = loc.sitename
          }
          this.$log.debug(' &&&&&& our name is ', name)
          if (value.siteunitsprofile) {
            let shop = {
              idnum: key,
              safeid: Object.values(value.siteunitsprofile)[0].crypto_idnum,
              sitename: name,
              sitelabel: loc.sitename
            }
            this.groupsites.push(shop)
          }
          // this.$log.debug(key,value.siteunitsprofile)
        }
        this.$log.debug('our location map ', this.groupsites)
        return this.groupsites
      }
    },
    watch: {
      loading (val) {
        if (!val) return

        setTimeout(() => (this.loading = false), 1000)
      }
    },
    created () {
      this.loading = true
      this.$log.debug('ID PASSED ', this.$route.params.id)
      this.id = this.$route.params.id
      this.$log.debug('id passed is ', this.id)
      // let j = Object.keys(loadedprofiles)
      // get the units for this group for today
      this.date = moment().subtract(1, 'day').format('YYYY-MM-DD')
      this.filenamedate = this.date
      let params = {
        group: this.id,
        startdate: this.startdate,
        enddate: this.enddate
      }
      this.$log.debug(params)
      this.$store.dispatch('loadgroupeods', params)
    },
    methods: {
      save () {
        let allowedchars = ''
        allowedchars = this.editedItem.accesscode.match(/^[0-9]*$/gi)
        this.$log.debug('allowedchars ', allowedchars)
        if (!allowedchars) {
          this.alertmessage = 'Only numbers are allowed in PIN numbers'
          this.snackbar = true
          this.close()
          return
        }
        // check for leading zero (pins are ints)
        if (this.editedItem.accesscode[0] === '0') {
          this.$log.debug('no leading zeros allowed ')
          this.alertmessage = 'PINs can not have leading zeros'
          this.snackbar = true
          this.close()
          return
        }
        // check to see if the pin is unique
        let not_allowed_pins = this.depositusers.map(element => element.accesscode)
        this.$log.debug('list of users ', this.depositusers)
        let reserved_pins = ['0000', '9999']

        let PIN_LENGTH = 4

        let pin_present = not_allowed_pins.includes(this.editedItem.accesscode)
        if (pin_present) {
          this.alertmessage = 'PINs must be unique per safe'
          this.snackbar = true
          this.close()
          return
          // we found their pin already present so say nooooo
        }
        if (this.editedItem.accesscode.length !== PIN_LENGTH) {
          this.alertmessage = 'PINs must be 4 digits with no leading zeros, and not be reserved values'
          this.snackbar = true
          this.close()
          return
          // we found their pin already present so say nooooo
        }
        this.$log.debug('EDITED INDEX WAS ', this.editedIndex)
        const user = {
          siteid: this.sitedetails.idnum,
          username: this.editedItem.username.trim(),
          email: this.editedItem.email.trim(),
          usertype: this.editedItem.usertype,
          accesscode: this.editedItem.accesscode.trim(),
          key: this.editedItem.key
        }
        if (this.editedIndex > -1) {
          let userrec = {
            safeid: this.id,
            username: user.username,
            userpin: user.accesscode,
            usertype: user.usertype
          }
          this.$store.dispatch('addsafeusercmd', userrec)
          Object.assign(this.depositusers[this.editedIndex], this.editedItem)
          this.$log.debug('CALLING UPDATE IN VIEW ')
          this.$store.dispatch('updateDeposituser', user)
          this.close()
        } else {
          this.depositusers.push(this.editedItem)
          this.$store.dispatch('createDeposituser', user)
          // we add this to mqtt here also
          let userrec = {
            safeid: this.id,
            username: user.username,
            userpin: user.accesscode,
            usertype: user.usertype
          }
          this.$store.dispatch('addsafeusercmd', userrec)
          this.$store.dispatch('loadDepositusers', this.sitedetails.idnum)
          this.depositusers = this.$store.getters.depositusers
          this.close()
        }
        this.close()
      },
      onChange (value) {
        this.$refs.menu.save(value)
        this.$log.debug('value passed to on change function ', value)
        let newdate = moment(value, 'YYYY-MM-DD').format('YYYY-MM-DD')
        this.filenamedate = newdate
        let params = {
          group: this.id,
          startdate: this.startdate,
          enddate: this.enddate
        }
        this.date = newdate
        this.$log.debug('new params ', params)
        let sd = moment(params.startdate, 'YYYY-MM-DD')
        let ed = moment(params.enddate, 'YYYY-MM-DD')
        let span = ed.diff(sd, 'days')
        if (span >= 0) {
          this.$store.dispatch('loadgroupeods', params)
        } else {
          this.$log.debug('set the snackbar error to true')
        }
      },
      onEndChange (value) {
        this.$refs.menu1.save(value)
        this.$log.debug('value passed to on end change function ', value)
        let newdate = moment(value, 'YYYY-MM-DD').format('YYYY-MM-DD')
        this.filenamedate = newdate
        let params = {
          group: this.id,
          startdate: this.startdate,
          enddate: this.enddate
        }
        this.date = newdate
        this.$log.debug('new params ', params)
        let sd = moment(params.startdate, 'YYYY-MM-DD')
        let ed = moment(params.enddate, 'YYYY-MM-DD')
        let span = ed.diff(sd, 'days')
        if (span >= 0) {
          this.$store.dispatch('loadgroupeods', params)
        } else {
          this.$log.debug('set the snackbar error to true')
        }
      },
      format_time (ts) {
        this.$log.debug('TS ', ts)
        return moment(ts).format('DD-MM-YYYY HH:mm:ss')
      },
      format_amt (amt) {
        this.$log.debug('amt ', amt)
        return numeral(amt).format('$0,0.00')
      },
      getsitesbygroup (group) {
        let grp = group
        this.locations = []
        for (let [key, value] of Object.entries(this.$store.getters.loadedSiteProfiles)) {
          let grp = 'Unknown'
          let loc = this.$store.getters.loadedSites.find(function (site) {
            if (site.idnum === key) {
              return site
            }
          })
          if (loc) {
            grp = loc.group
          }
          this.$log.debug(' our group is ', value.group, ' passed was ', grp)
          if (value.siteunitsprofile && value.group === grp) {
            this.$log.debug('adding')
            let shop = {
              idnum: key,
              safeid: Object.values(value.siteunitsprofile)[0].crypto_idnum,
            }
            this.locations.push(shop)
          }
        }
        this.$log.debug('our location map ', this.locations)
        return this.locations
      },
      getsitelabel (ssid) {
        // return ssid
        let label = 'unknown'
        // get list of sites in the system
        this.$store.getters.loadedSites.filter(function (site) {
          if (site.idnum === ssid) {
            label = site.sitename
          }
        })
        return label
        // loop thru, find name
        // return sitename
      },
      complete (index) {
        this.list[index] = !this.list[index]
      }
    }
  }
</script>
